export default __webpack_public_path__ + "static/media/ic_Payment_Successful.49292187.svg";